module.exports = __webpack_public_path__ + "assets/viva_food.b9bb3ac7ff4966bf7659c30bf7d66737.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/viva_food.jpg
// module id = 626
// module chunks = 0